import { RefObject } from 'react'
import { UploadFileProps } from '@wellesley/ui'
import useEventListener from 'hooks/useEventListener'

type HookProps = {
  addMedia: (files: UploadFileProps[]) => void
  containerRef: RefObject<HTMLDivElement>
}

const useUploadFromClipboard = ({ containerRef, addMedia }: HookProps) => {
  const onPaste = (e: ClipboardEvent) => {
    const clipboardItems = e.clipboardData?.items

    const items: DataTransferItem[] = [].slice
      .call(clipboardItems)
      ?.filter((item: DataTransferItem) => /^image|video\//.test(item.type))

    if (items.length) {
      // insert copied files without filenames
      e.preventDefault()
    }

    const mappedFiles = items
      .map((item) => {
        const file = item.getAsFile()

        if (!file) return null

        return {
          file: item.getAsFile(),
          objectUrl: URL.createObjectURL(file),
        }
      })
      .filter(Boolean) as UploadFileProps[]

    mappedFiles.length && addMedia(mappedFiles)

    return () =>
      mappedFiles.forEach((item) => URL.revokeObjectURL(item.objectUrl))
  }

  useEventListener('paste', onPaste, containerRef.current)
}

export default useUploadFromClipboard
